<template>
    <div class="form-group bs-form-group">
        <label v-if="label" :for="name" class="text-uppercase mb-0">{{ label }}</label>
        <vue-upload-multiple-image
                @upload-success="uploadImageSuccess"
                @before-remove="beforeRemove"
                @edit-image="editImage"
                @data-change="dataChange"
                :data-images="images"
                :dragText="$t('labels.drag_image')"
                :browseText="$t('labels.browse_image')"
                :dropText="$t('labels.drop_image')"
                :primaryText="$t('labels.primary_image')"
                :markIsPrimaryText="$t('labels.make_primary_image')"
                :popupText="null"
        ></vue-upload-multiple-image>
        <small class="form-text text-danger" v-if="error && error[name]">{{ error[name][0] }}</small>
        <small class="form-text text-muted" v-else-if="help">{{ help }}</small>
    </div>
</template>

<script>
import VueUploadMultipleImage from 'vue-upload-multiple-image'
import helpers from '../../helpers'
export default {
  name: 'MultiImageUpload',
  components: {
    VueUploadMultipleImage
  },
  props: ['type', 'label', 'name', 'help', 'value', 'error'],
  data () {
    return {
      images: []
    }
  },
  // mounted () {
  //   this.images = this.value
  // },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    uploadImageSuccess (formData, index, fileList) {
      const files = []
      fileList.forEach(function (file) {
        files.push(helpers.base64ToFile(file.path, file.name))
      })
      this.$emit('input', files)
    },
    beforeRemove (index, done, fileList) {
      done()
    },
    editImage (formData, index, fileList) {
      const files = []
      fileList.forEach(function (file) {
        files.push(helpers.base64ToFile(file.path, file.name))
      })
      this.$emit('input', files)
    },
    dataChange (data) {
    }
  }
}
</script>

<style lang="scss">
    .bs-form-group {
        > label {
            font-size: 0.75rem;
            font-weight: 600;
        }
    }
</style>
